import { isUserInTestBucket } from '@at/ab-test-utils'
import { atdsTheme } from '@at/design-system-foundation'
// eslint-disable-next-line import/no-unresolved
import { DefaultTheme } from '@at/design-system-tokens/dist/styles'

const redDefault = atdsTheme.color.bgFill.brand.default
const redHover = atdsTheme.color.bgFill.brand.hover
const midnight = atdsTheme.v1.color.blue.dark

export const redButtonTheme: DefaultTheme = {
    ...atdsTheme,
    v1: {
        ...atdsTheme.v1,
        badges: {
            ...atdsTheme.v1.badges,
            default: {
                background: midnight,
                color: atdsTheme.color.text.brand.default,
            },
        },
        buttons: {
            ...atdsTheme.v1.buttons,
            primary: {
                ...atdsTheme.v1.buttons.primary,
                default: {
                    ...atdsTheme.v1.buttons.primary.default,
                    background: {
                        ...atdsTheme.v1.buttons.primary.default.background,
                        default: redDefault,
                        hover: redHover,
                        active: redHover,
                    },
                },
                inverted: {
                    ...atdsTheme.v1.buttons.primary.inverted,
                    foreground: {
                        ...atdsTheme.v1.buttons.primary.inverted.foreground,
                        default: midnight,
                        hover: redDefault,
                        active: redDefault,
                    },
                },
            },
            secondary: {
                ...atdsTheme.v1.buttons.secondary,
                default: {
                    ...atdsTheme.v1.buttons.secondary.default,
                    foreground: {
                        ...atdsTheme.v1.buttons.secondary.default.foreground,
                        default: midnight,
                        hover: midnight,
                        active: midnight,
                    },
                },
            },
            tertiary: {
                ...atdsTheme.v1.buttons.tertiary,
                default: {
                    ...atdsTheme.v1.buttons.tertiary.default,
                    background: {
                        ...atdsTheme.v1.buttons.tertiary.default.background,
                        hover: atdsTheme.color.button.bgFill.contrast.hover,
                        active: atdsTheme.color.button.bgFill.contrast.active,
                    },
                    foreground: {
                        ...atdsTheme.v1.buttons.tertiary.default.foreground,
                        default: midnight,
                        hover: redDefault,
                        active: redDefault,
                    },
                },
            },
        },
        link: {
            ...atdsTheme.v1.link,
            default: midnight,
            hover: redDefault,
            active: redDefault,
            visited: midnight,
            disabled: atdsTheme.color.bgFill.disabled,
        },
    },
}

export const isRedButtonTestActive = isUserInTestBucket('rbT') || isUserInTestBucket('rbT2')
